"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _generic = _interopRequireDefault(require("../icons/generic"));
var _utils = require("../../utils/utils");
// Packages

// Components

// Utils

// Styles
const {
  above
} = (0, _utils.getMediaQueries)();
const CategoryLinkContainer = _styledComponents.default.div.withConfig({
  displayName: "search-nav-items__CategoryLinkContainer",
  componentId: "sc-2e2um2-0"
})(["display:flex;justify-content:space-between;align-items:center;margin-top:", ";border-bottom:", ";a{color:var(--dusky-grey-6-hex);font-weight:600;font-size:14px;line-height:20px;padding:20px 0;", " &:hover{text-decoration:none;}}"], props => props.searchBoxFocus ? "8px" : "0", props => props.searchBoxFocus ? "1px solid #E5EAF1" : "none", above.tablet`
    // margin-right:24px;
    font-size:16px;
    `);
const LinkContainerTabletDesktop = _styledComponents.default.ul.withConfig({
  displayName: "search-nav-items__LinkContainerTabletDesktop",
  componentId: "sc-2e2um2-1"
})(["display:none;", " ", " a{align-items:center;display:flex;position:relative;::before{content:\"\";position:absolute;width:100%;height:2px;bottom:10px;left:0;background-color:var(--pacific-blue-hex);visibility:hidden;transform:scaleX(0);transition:0.3s ease-in-out;}:hover{::before{visibility:visible;transform:scaleX(1);}}&.active{::before{visibility:visible !important;transform:scaleX(1) !important;}}}.mortgage{::before{background-color:#6ecef7;}}.financial{::before{background-color:#60e9c9;}}.home{::before{background-color:#ffa979;}}.KC{span{display:none;margin-left:4px;}@media (min-width:834px){span{display:inline-block;}}}"], above.mobile`
    display: flex;
    gap: 16px;
  `, above.tablet`
    gap: 32px;
  `);
const LinkContainerMobile = (0, _styledComponents.default)(LinkContainerTabletDesktop).withConfig({
  displayName: "search-nav-items__LinkContainerMobile",
  componentId: "sc-2e2um2-2"
})(["display:flex;gap:16px;", ""], above.mobile`
    display:none;
  `);
const CloseButton = _styledComponents.default.button.withConfig({
  displayName: "search-nav-items__CloseButton",
  componentId: "sc-2e2um2-3"
})(["background:none;color:inherit;border:none;padding:0;font:inherit;cursor:pointer;outline:inherit;display:", ";"], props => props.searchBoxFocus ? "initial" : "none");
const CloseButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "search-nav-items__CloseButtonContainer",
  componentId: "sc-2e2um2-4"
})(["p{color:var(--dusky-grey-6-hex);font-size:12px;line-height:15.08px;margin-bottom:0;}display:flex;align-items:center;"]);
const SearchNavItems = props => {
  const {
    searchBoxFocus,
    setSearchBoxFocus
  } = props;
  const mobileNavItems = props.mobileNavItems || props.navItems;
  return /*#__PURE__*/_react.default.createElement(CategoryLinkContainer, {
    searchBoxFocus: props.searchBoxFocus
  }, /*#__PURE__*/_react.default.createElement(LinkContainerMobile, {
    bottomPosition: props.articleSlug ? "10px" : 0
  }, mobileNavItems && mobileNavItems.map((item, i) => {
    return item;
  })), /*#__PURE__*/_react.default.createElement(LinkContainerTabletDesktop, {
    bottomPosition: props.articleSlug ? "10px" : 0
  }, props.navItems && props.navItems.map((item, i) => {
    return item;
  })), /*#__PURE__*/_react.default.createElement(CloseButton, {
    searchBoxFocus: searchBoxFocus,
    onClick: () => {
      setSearchBoxFocus(false);
    }
  }, /*#__PURE__*/_react.default.createElement(CloseButtonContainer, null, /*#__PURE__*/_react.default.createElement("p", null, "close"), /*#__PURE__*/_react.default.createElement(_generic.default, {
    icon: "x-close",
    color: _utils.colors["grey-4"].hex,
    title: ""
  }))));
};
SearchNavItems.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SearchNavItems"
};
var _default = SearchNavItems;
exports.default = _default;